// Palette colori per le aree funzionali
export const functionalAreaColors: Record<string, string> = {
  P: '#fa938e',
  A: '#98bf45',
  G: '#51cbcf',
  other: '#9E9E9E', // Grigio per Altro
};

